// 第一版 勿删，还会再用 2024年01月09日
// const guidanceConfigArray = [
//   {
//     title: 'Enter Prompt',
//     content: 'Click to type a prompt. It should include a subject.',
//     alias: 'Enter',
//   },
//   {
//     title: 'Choose a suggestion',
//     content: 'Click to choose a suggestion based on your input.',
//     alias: 'ChooseSuggestion',
//   },
//   {
//     title: 'Choose a style',
//     content: 'Click to choose an art style you like.',
//     alias: 'ChooseStyle',
//   },
//   {
//     title: 'Select a style',
//     content: 'Click on a style cover to set it to your generation.',
//     alias: 'SelectStyle',
//   },
//   {
//     title: 'Generate your image!',
//     content: 'Click to start your generation.',
//     alias: 'Generate',
//   },
//   {
//     title: 'Inspired by community',
//     content: 'Hover to open community gallery.',
//     alias: 'Inspired',
//   },
//   {
//     title: 'Community inspirations',
//     content: 'Click to see details of the  image on canvas.',
//     alias: 'Community',
//   },
//   {
//     title: 'Remix your image!',
//     content: 'You can make changes and remix new images.',
//     alias: 'RemixNow',
//   },
//   {
//     title: 'Import your own inspiration',
//     content: 'Click to upload any image.',
//     alias: 'Import',
//   },
//   {
//     title: 'Remix',
//     content: 'Automatically generate prompt and match style.',
//     alias: 'GeneratePrompt',
//   },
//   {
//     title: 'End of the guidance',
//     content: 'Now you can use Shakker freely. Enjoy your journey of creation!',
//     alias: 'End',
//   },
// ];

import { translate } from '@shakkerai/util-i18n';

const guidanceConfigArray = [
  {
    title: translate('Landing_step1_title'),
    content: translate('Landing_step1_content'),
    alias: 'Community',
  },
  {
    title: translate('Landing_step2_title'),
    content: translate('Landing_step2_content'),
    alias: 'RemixNow',
  },
  {
    title: translate('Landing_step3_title'),
    content: translate('Landing_step3_content'),
    alias: 'Import',
  },
  {
    title: translate('Landing_step4_title'),
    content: translate('Landing_step4_content'),
    alias: 'GeneratePrompt',
  },
  {
    title: translate('Landing_restart_title'),
    content: translate('Landing_restart_content'),
    alias: 'End',
  },
];

const guidanceConfig = {};

guidanceConfigArray.forEach((item, index) => {
  guidanceConfig[item.alias] = {
    ...item,
    index,
  };
});

/**
 * 对外使用的，包含了索引位置
 */
export const guidanceConfigIndexArray = Object.values(guidanceConfig);

/**
 * 获取引导的目标配置
 * @param {*} alias
 * @returns
 */
export const getGuidanceConfig = (alias) => {
  const targetConfig = guidanceConfig[alias];

  if (targetConfig) {
    targetConfig.title = `${targetConfig.title}`;
    targetConfig.indexStr = `${targetConfig.index + 1}/${guidanceConfigArray.length - 1}`; // 最后一步不算在步骤内
    return targetConfig;
  } else {
    // throw Error(`Guidance config error: ${alias} is not exist.`);
    return {
      title: 'Unknown:' + alias,
      content: 'Unknown',
    };
  }
};
